<template>
   
    <div class="caption-host">
        <div v-if="!started">
            <h1>Host a new session</h1>

            <!----<div><input type="password" v-model="password" placeholder="Password to host a session" /></div>-->
            <div><input type="text" v-model="name" placeholder="Session Name" id="text" /></div>
            <div>Select spoken lanauge:
                <select v-model="fromLanguage">
                    <option v-for="lang in fromLanguages" :value="lang" :key="lang">
                        {{ lang.substring(0, 2) }}
                    </option>
                </select><br />
                <button @click="start">Start</button>
            </div>
        </div>
        <div v-else>
            
            <button @click="stop">stop</button>
            <div id="currentSentence" class="caption">
                {{ currentSentence }}
            </div>
        </div>
        <div class="footer">
            <center>Copyright by Moresi.com SA 2022 - Powered by Microsoft Azure Services - <a href="/credits">Credits</a></center>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import constants from '../lib/constants'
import Translator from '../lib/translator'
import languageListMixin from '../lib/language-list-mixin'

const passwordKey = 'passwordKey'
const nameKey = 'sessionNameKey'

export default {
  mixins: [languageListMixin],
  data() {
    return {
      key: constants.ttsKey || '',
      password: localStorage.getItem(passwordKey) || '',
      name: window.localStorage.getItem(nameKey) || '',
      region: `${constants.region}`,
      currentSentence: '',
      started: false,
      fromLanguage: 'en-US'
    }
  },
  watch: {
    password(newPassword) {
      window.localStorage.setItem(passwordKey, newPassword);
    },
    name(newName) {
      window.localStorage.setItem(nameKey, newName);
    }
  },
  created() {
    this.translator = new Translator(function (captions) {
      this.currentSentence = captions.original;
      captions.translations.sessionName = this.name;
      console.log(captions);
      axios.post(`${constants.apiBaseUrl}/api/captions`,
        captions.translations);
    }.bind(this))
  },
  methods: {
    start() {
      this.translator.start({
        key: this.key,
        region: this.region,
        fromLanguage: this.fromLanguage,
        toLanguages: this.toLanguages
      })
      this.started = true
    },
    stop() {
      this.started = false
      this.currentSentence = ''
      this.translator.stop()
    }
  },
  beforeDestroy() {
    this.translator.stop()
  }
}
</script>

<style scoped>
input[type=password] {
  width: 600px;
}

.footer
{
  margin-top: 20px;
  position: relative;
  bottom: 0;
  padding: 10px;
}

.footer img
{
  width: 20%;
}
</style>